import { defineStore } from 'pinia';
import useQueueStore from '@/stores/manuscripts/queue';

const queueStore = useQueueStore({
  queueItemsPath: '/manuscripts/',
  guidSearchParam: 'studio_id',
  queueItemIdField: 'manuscript_id',
  queueItemIdFilterField: 'manuscript_id',
  queueItemSearchParams: {
    is_imported: 1,
  },
  queueItemUpdateFields: [
    'import_meta',
    'title',
  ],
});

const useImportQueueStore = defineStore('manuscript-import-queue', queueStore);

export default useImportQueueStore;
